module.exports = __webpack_public_path__ + "static/media/logo-asisa-white.6e54b89d.svg";